// extracted by mini-css-extract-plugin
export default {"MainCont":"Chilling_MainCont__TE9+Y","LeftCont":"Chilling_LeftCont__6ckAC","RightCont":"Chilling_RightCont__VanhW"};